/**
 * 404 / not-found route.
 *
 * P7 placement (plan 2026-06-10-pip-mascot-placement.md §4):
 *   Idle 88px Pip above "Nothing here." + "Back to your recipes" link.
 *   Lore line: "Pip is a piece of starter." — plan §0 "the only approved
 *   character copy, 404 only until an about surface exists."
 *
 * Voice: precise, quiet, no exclamation, no "Oops!" — branding.md §5.
 * No copy changes to the 404 link text; plan says "No copy changes unless
 * the plan specifies." The plan specifies "Nothing here." and the lore line.
 */

import { Link } from "react-router";
import { Wordmark } from "~/components/Wordmark";
import { PipMascot } from "~/components/pip/PipMascot";

export default function NotFound() {
  return (
    <div
      style={{
        minHeight: "100dvh",
        background: "var(--bg)",
        color: "var(--text)",
        fontFamily: "var(--font-sans)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "var(--space-4)",
        padding: "var(--card-padding-mobile)",
      }}
    >
      <Wordmark size={24} />
      {/*
       * P7 — Pip at 88px, resting idle-breath pose (plan §4 P7 spec).
       * role="img" + title because standalone (no adjacent text to shadow it).
       * Rule 7: 88px at 375px = 23% of viewport width — comfortable, no overlap.
       */}
      <PipMascot size={88} title="Pip" />
      <p
        style={{
          color: "var(--muted)",
          fontSize: "13px",
          fontFamily: "var(--font-mono)",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        404
      </p>
      {/* plan §4 P7 copy: "Nothing here." */}
      <p style={{ color: "var(--text)", fontSize: "15px" }}>Nothing here.</p>
      {/* plan §0 lore line — 404 only */}
      <p
        style={{
          color: "var(--muted)",
          fontSize: "13px",
        }}
      >
        Pip is a piece of starter.
      </p>
      {/* plan §4 P7 link: "Back to your recipes" */}
      <Link
        to="/app"
        style={{
          color: "var(--text)",
          fontSize: "13px",
          textDecoration: "none",
          borderBottom: "1px solid var(--text)",
          paddingBottom: "1px",
          transition: "opacity var(--motion-state)",
        }}
      >
        Back to your recipes
      </Link>
    </div>
  );
}
